import styled from 'styled-components'

import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledErrorMessage = styled.div`
  color: ${(props: any) => themeUtilities.getRgbaColor(props.theme, 'colors.attention.normal')};
  font-size: ${(props: any) => themeUtilities.getFontSize(props.theme, 'default')}px;
`

export default StyledErrorMessage
